module.exports = __webpack_public_path__ + "static/media/supper.124d3dda.jpg";